import type { I18NMessages } from '@atlaskit/intl-messages-provider/types';
import { createFetchMessagesForLocale } from '@atlassian/atlassian-studio-ui-components/fetch-messages-for-locale';

import defaultMessages from './en';

const asyncLanguages = {
	cs: () =>
		import(/* webpackChunkName: "@atlaskit-internal_@atlassian/agent-studio-i18n-cs" */ './cs'),
	da: () =>
		import(/* webpackChunkName: "@atlaskit-internal_@atlassian/agent-studio-i18n-da" */ './da'),
	de: () =>
		import(/* webpackChunkName: "@atlaskit-internal_@atlassian/agent-studio-i18n-de" */ './de'),
	'en-GB': () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/agent-studio-i18n-en_GB" */ './en_GB'
		),
	'en-ZZ': () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/agent-studio-i18n-en_ZZ" */ './en_ZZ'
		),
	en: () =>
		import(/* webpackChunkName: "@atlaskit-internal_@atlassian/agent-studio-i18n-en" */ './en'),
	es: () =>
		import(/* webpackChunkName: "@atlaskit-internal_@atlassian/agent-studio-i18n-es" */ './es'),
	fi: () =>
		import(/* webpackChunkName: "@atlaskit-internal_@atlassian/agent-studio-i18n-fi" */ './fi'),
	fr: () =>
		import(/* webpackChunkName: "@atlaskit-internal_@atlassian/agent-studio-i18n-fr" */ './fr'),
	hu: () =>
		import(/* webpackChunkName: "@atlaskit-internal_@atlassian/agent-studio-i18n-hu" */ './hu'),
	it: () =>
		import(/* webpackChunkName: "@atlaskit-internal_@atlassian/agent-studio-i18n-it" */ './it'),
	ja: () =>
		import(/* webpackChunkName: "@atlaskit-internal_@atlassian/agent-studio-i18n-ja" */ './ja'),
	ko: () =>
		import(/* webpackChunkName: "@atlaskit-internal_@atlassian/agent-studio-i18n-ko" */ './ko'),
	nb: () =>
		import(/* webpackChunkName: "@atlaskit-internal_@atlassian/agent-studio-i18n-nb" */ './nb'),
	nl: () =>
		import(/* webpackChunkName: "@atlaskit-internal_@atlassian/agent-studio-i18n-nl" */ './nl'),
	pl: () =>
		import(/* webpackChunkName: "@atlaskit-internal_@atlassian/agent-studio-i18n-pl" */ './pl'),
	'pt-BR': () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/agent-studio-i18n-pt_BR" */ './pt_BR'
		),
	ru: () =>
		import(/* webpackChunkName: "@atlaskit-internal_@atlassian/agent-studio-i18n-ru" */ './ru'),
	sv: () =>
		import(/* webpackChunkName: "@atlaskit-internal_@atlassian/agent-studio-i18n-sv" */ './sv'),
	th: () =>
		import(/* webpackChunkName: "@atlaskit-internal_@atlassian/agent-studio-i18n-th" */ './th'),
	tr: () =>
		import(/* webpackChunkName: "@atlaskit-internal_@atlassian/agent-studio-i18n-tr" */ './tr'),
	uk: () =>
		import(/* webpackChunkName: "@atlaskit-internal_@atlassian/agent-studio-i18n-uk" */ './uk'),
	vi: () =>
		import(/* webpackChunkName: "@atlaskit-internal_@atlassian/agent-studio-i18n-vi" */ './vi'),
	zh_TW: () =>
		import(
			/* webpackChunkName: "@atlaskit-internal_@atlassian/agent-studio-i18n-zh_TW" */ './zh_TW'
		),
	zh: () =>
		import(/* webpackChunkName: "@atlaskit-internal_@atlassian/agent-studio-i18n-zh" */ './zh'),
} as const;

export const fetchMessagesForLocale: (locale: string) => Promise<I18NMessages> =
	createFetchMessagesForLocale(asyncLanguages, defaultMessages);

export { defaultMessages };
